/* eslint-disable max-len */
import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import moTrend, {
  trendInit, changeTab, changeType,
} from './store/index';
import Left from './left';
import IncomeRight from '../../component/income-right';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import NewIncome from '../../component/new-income';
import Income from '../../component/income';
import { exportExcelFile } from '@/tool';
import moMenu from '../../store/menu';

interface IProps {}
interface IState {}

const TimeTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    tabList, tabActive, type, empty,
    totalXLeftData, totalXRightData, totalYData,
    tableTitle, tableList, overview,
    dev, admin, sale, yData,
  } = moTrend;
  const dom1556 = useRef(null);

  const exporttable = () => {
    const head:any = [
      ['年份', '薪酬成本占比', '占比变化', '研发类薪酬占比', '销售类薪酬占比', '管理类薪酬占比'],
    ];
    console.log(tableList);
    const list:any = [...head, ...tableList];
    const merge:any = [];
    exportExcelFile(list, merge, '时间趋势');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="effect09" className="income-time-trend_10 box-111">
      <SubTitle title="时间趋势" subtitle={moMenu.industryName} active={type}
        bg={Color.primaryColor(0.1)} color={Color.primary}
        tabChange={(val: string) => changeType(val)}
        contentList={[
          '薪酬成本占比的计算方式：将该行业下所有样本公司的薪酬成本加总，然后除以所有样本公司的营业收入加总。薪酬成本占比 = 总薪酬成本 / 营业收入',
          '研发类薪酬占比的计算方式：将该行业下所有样本公司的研发类员工的薪酬加总，然后除以所有样本公司的薪酬成本加总。研发类薪酬占比 = 研发类员工的薪酬 / 总薪酬成本',
          '销售类薪酬占比、管理类薪酬占比的计算方式与研发类薪酬占比计算方式相同。',
        ]} />
      {type === 'chart' ? (
        <section className="content-151">
          {!empty ? (
            <>
              <section className="tab-1010">
                <Tab list={tabList} active={tabActive} onChange={changeTab} />
              </section>
              <section className="content-1015"
                style={{ flexDirection: tabActive === '总薪酬成本占比' ? 'row' : 'column' }}>
                {tabActive === '总薪酬成本占比' ? (
                  <section className="content-1030">
                    <section className="left-1011">
                      <p className="line-1011">
                        <strong>薪酬成本占比</strong>
                        <span className="text-1011">&nbsp;=&nbsp;总薪酬成本 / 营业收入</span>
                      </p>
                      <Left height={300} xData={totalXLeftData} yData={totalYData} name="薪酬成本占比" />
                    </section>
                    <section className="right-1011">
                      <p className="line-1011"><strong>占比变化</strong></p>
                      <IncomeRight height={300} xData={totalXRightData} yData={totalYData} name="占比变化" />
                    </section>
                  </section>
                ) : (
                  <section className="content-1030">
                    <section className="fee-1011">
                      <p className={'line-1019 line-1011'}
                        style={{ borderBottom: 'none' }}>
                        <strong>研发类薪酬占比</strong>
                      </p>
                      <Income height={300} xData={dev} yData={yData}
                        bgColor={Color.d9Color(0.05)} name="研发类薪酬占比" />
                    </section>
                    <section className="fee-1011">
                      <p className={'line-1011'} style={{ borderBottom: 'none' }}>
                        <strong>销售类薪酬占比</strong>
                      </p>
                      <NewIncome height={300} xData={sale} yData={yData}
                        bgColor={Color.secondaryColor(0.05)} name="销售类薪酬占比" />
                    </section>
                    <section className="fee-1011">
                      <p className={'line-1011'} style={{ borderBottom: 'none' }}>
                        <strong>管理类薪酬占比</strong>
                      </p>
                      <NewIncome height={300} xData={admin} yData={yData}
                        bgColor={Color.twoColor(0.05)} name="管理类薪酬占比" />
                    </section>
                  </section>
                )}
                <section className="chart-detail_11 industry-detail_11"
                  style={{
                    width: tabActive === '总薪酬成本占比' ? '410px' : '100%',
                    marginTop: '26px',
                    height: tabActive === '总薪酬成本占比' ? '300px' : 'auto',
                  }}>
                  {overview.map((item: any, index: number) => (
                    <section key={index} className="item">
                      <span className="circle-111"><b /></span>
                      <p className="line-111">
                        {item.map((child: any, idx: number) => (
                          <Fragment key={idx}>
                            {child.mark === 'number' ? (
                              <span className="blue-11">{`${round(child.value * 100, 1)}%`}</span>
                            ) : null}
                            {child.mark === 'change_ratio' ? (
                              <>
                                {child.value >= 0 ? (
                                  <span className="red-11">{`${round(child.value * 100, 1)}%`}</span>
                                ) : (
                                  <span className="green-11">{`${round(child.value * 100, 1)}%`}</span>
                                )}
                              </>
                            ) : null}
                            {(child.mark !== 'number' && child.mark !== 'change_ratio') ? (
                              <span className="span-11">{child.value}</span>
                            ) : null}
                          </Fragment>
                        ))}
                      </p>
                    </section>
                  ))}
                </section>
              </section>
            </>
          ) : (<Empty />)}
        </section>
      ) : (
        <section className="content-151">
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!empty ? (
            <CommonTable titleList={tableTitle} list={tableList} />
          ) : (<Empty />)}
        </section>
      )}
    </section>
  );
};

export default observer(TimeTrend);
